import { get } from 'lodash';

/**
 * Device Service
 * Handles device validation and queries
 */

const DEVICE_MULTI_HOMED_API_URL = '/ipm/v1/admin/monitoredDeviceConfig/multiHomedPrimary';

/**
 * Check if a device IP is multi-homed (already monitored under different IP)
 * @param {Object} dataService - The data service instance
 * @param {string} deviceIp - The IP address to check
 * @returns {Promise<Object|null>} Primary device object if multi-homed, null otherwise
 */
export async function checkMultiHomedDevice(dataService, deviceIp) {
    try {
        const response = await dataService.get(`${DEVICE_MULTI_HOMED_API_URL}/${deviceIp}`);
        return response;
    } catch (error) {
        // If API returns error or 404, device is not multi-homed
        return null;
    }
}

/**
 * Validate that a device IP is not multi-homed
 * @param {Object} dataService - The data service instance
 * @param {string} deviceIp - The IP address to validate
 * @returns {Promise<{isValid: boolean, primaryIp?: string}>} Validation result with primary IP if multi-homed
 */
export async function validateNotMultiHomed(dataService, deviceIp) {
    try {
        const primaryDevice = await checkMultiHomedDevice(dataService, deviceIp);

        // If no primary device or no ipAddress, validation passes
        if (!primaryDevice || !get(primaryDevice, 'ipAddress')) {
            return { isValid: true };
        }

        // Device is multi-homed, return primary IP
        return {
            isValid: false,
            primaryIp: get(primaryDevice, 'ipAddress'),
        };
    } catch (error) {
        // On error, assume validation passes (don't block user)
        return { isValid: true };
    }
}
